import type { BackendRouteDefinition } from '../types';

/**
 * Migrated to `api-core-node` in PRA-802 (Phase 5 / Sub-phase 8 / S8-WB1).
 * The `dailySummarySecondGen` callable stays deployed in `cloudFunctions/`
 * until the Sub-phase 9 retirement sweep.
 */
export const dailySummaryRoute = {
  transport: 'api',
  method: 'POST',
  path: '/firms/insurance:daily-summary',
} as const satisfies BackendRouteDefinition;
